import { CardList } from '../../../../../../../commonComponents/CardList';
import { RegionList, RegionsHeader, RegionsSubHeader } from './components';

export const RegionsCard = () => (
  <CardList Header={RegionsHeader} SubHeader={RegionsSubHeader} List={RegionList} />
);
